var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reg-filter", class: { "reg-watch": _vm.isRegWatch } },
    [
      _c(
        "div",
        { class: { compact: _vm.isCompact }, attrs: { id: "activityFilter" } },
        [
          _vm.collapsed
            ? _c(
                "div",
                {
                  staticClass: "reg-dropdown text-right cursor-pointer",
                  class: {
                    "hide-field": !_vm.collapsed,
                    "reg-watch": _vm.isRegWatch,
                  },
                  attrs: { "data-toggle": "dropdown" },
                  on: {
                    click: function ($event) {
                      return _vm.showHideFilter()
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass:
                        "dropdown-toggle cursor vertical-align-middle",
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/images/icons/filter.svg",
                          alt: "filter-icon",
                        },
                      }),
                      _vm.showFilterIcon
                        ? _c("span", { staticClass: "count" }, [
                            _c("span", {
                              staticClass: "glyphicon glyphicon-ok",
                            }),
                          ])
                        : _vm._e(),
                      _c("img", {
                        class: { "pl-6": !_vm.isCompact },
                        attrs: {
                          src: "/static/images/icons/chevron_right.svg",
                          alt: "chevronright-icon",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dropdown-menu dropdown-menu-left filter-ul",
              class: { "hide-field": _vm.collapsed },
            },
            [
              _c(
                "div",
                { staticClass: "col-xs-12 pb-1 pl-0 pr-0 filter-text" },
                [
                  _vm._m(0),
                  _c(
                    "div",
                    { staticClass: "col-xs-11 font-properties pl-0 pt-3" },
                    [_vm._v("Filter")]
                  ),
                  _c("div", { staticClass: "col-xs-1 pr-0" }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.showHideFilter(true)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass:
                            "image-size cursor-pointer left-transform cursor",
                          attrs: {
                            src: "/static/images/icons/chevron_right.svg",
                            alt: "chevronright-icon",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 filter-wrapper p-0" },
                [
                  _vm.types.label === "records"
                    ? _c("div", { staticClass: "col-xs-12 p-0" }, [
                        _vm.permissions.includes("RECORDS_WITH_ATTACHMENT")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 item-divider p-0 cursor-pointer flex-between",
                                on: {
                                  click: function ($event) {
                                    return _vm.filterWithType("attachment")
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-10 p-0 font-properties font-bold pl-13",
                                  },
                                  [_vm._v(" Records With Attachments ")]
                                ),
                                _vm.filterOptions.attachment
                                  ? _c("img", {
                                      staticClass:
                                        "col-xs-2 text-right p-0 image-size",
                                      attrs: {
                                        src: "/static/images/icons/check.svg",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm.permissions.includes("AFFECTED_BY_REGULATORY_ALERT")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 item-divider p-0 cursor-pointer flex-between",
                                on: {
                                  click: function ($event) {
                                    return _vm.filterWithType("regulatoryAlert")
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "font-properties font-bold pl-13",
                                  },
                                  [_vm._v("Affected By Regulatory Alert")]
                                ),
                                _vm.filterOptions.regulatoryAlert
                                  ? _c("img", {
                                      staticClass: "text-right image-size",
                                      attrs: {
                                        src: "/static/images/icons/check.svg",
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.chevronList, function (value, keyValue) {
                    return _c(
                      "div",
                      { key: keyValue, staticClass: "col-xs-12 p-0" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-xs-12 col-md-12 col-lg-12 item-divider p-0 cursor-pointer",
                            class: {
                              "hide-field":
                                (value === "Sub Category" &&
                                  !_vm.filterOptions.categories) ||
                                (_vm.types.label === "launchpadAccounts" &&
                                  value === "Account Status" &&
                                  !_vm.includeDeactivatedAccounts) ||
                                (_vm.types.label === "launchpadUsers" &&
                                  value === "User Status" &&
                                  !_vm.includeDeactivatedUsers) ||
                                (_vm.types.label === "regWatch" &&
                                  value === "Posted Date" &&
                                  !_vm.permissions.includes(
                                    "REG_WTCH_REG_UPD_POSTED_DATE_FILTER"
                                  )) ||
                                (_vm.types.label === "regWatch" &&
                                  value === "Effective Date" &&
                                  !_vm.permissions.includes(
                                    "REG_WTCH_REG_UPD_EFFECTIVE_DATE_FILTER"
                                  )) ||
                                (_vm.types.label === "regWatch" &&
                                  value === "Country" &&
                                  !_vm.permissions.includes(
                                    "REG_WTCH_REG_UPD_COUNTRY_FILTER"
                                  )) ||
                                (_vm.types.label === "records" &&
                                  value === "Country" &&
                                  !_vm.permissions.includes(
                                    "COUNTRY_WISE_FILTER_AND_SEARCH"
                                  )) ||
                                (_vm.types.label === "records" &&
                                  value === "Expiration Date" &&
                                  !_vm.permissions.includes(
                                    "EXPIRATION_DATES"
                                  )) ||
                                (_vm.types.label === "records" &&
                                  value === "Approval Date" &&
                                  !_vm.permissions.includes(
                                    "APPROVAL_DATES_WITH_OPTIONS"
                                  )) ||
                                (_vm.hideServicesForGlobalSearch &&
                                  value === "Services Registered"),
                            },
                            on: {
                              click: function ($event) {
                                _vm.toggleSelection(
                                  `collapse${value.replaceAll(" ", "")}`,
                                  keyValue
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-10 col-md-10 col-lg-10 p-0",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "font-properties font-bold pl-13",
                                    attrs: {
                                      "data-toggle": "collapse",
                                      role: "button",
                                      "aria-expanded": "false",
                                      "aria-controls": "collapseExpireyDate",
                                    },
                                  },
                                  [_vm._v(_vm._s(value))]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "col-xs-2 text-right pr-2" },
                              [
                                !_vm.selection[keyValue]
                                  ? _c("a", [
                                      _c("img", {
                                        staticClass: "chevron-image",
                                        attrs: {
                                          src: "/static/images/icons/chevron_down.svg",
                                          alt: "chevrondown-icon",
                                        },
                                      }),
                                    ])
                                  : _c("a", [
                                      _c("img", {
                                        staticClass:
                                          "chevron-image transform-img",
                                        attrs: {
                                          src: "/static/images/icons/chevron_down.svg",
                                          alt: "chevrondown-icon",
                                        },
                                      }),
                                    ]),
                              ]
                            ),
                          ]
                        ),
                        [
                          "collapseDocumentDate",
                          "collapsePostedDate",
                          "collapseApprovalDate",
                          "collapseDate",
                          "collapseDateCreated",
                        ].includes(`collapse${value.replaceAll(" ", "")}`)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-md-12 col-lg-12 collapse pr-0 item-divider",
                                class: [
                                  _vm.selection[keyValue] ? "in" : "",
                                  `collapse${value.replaceAll(" ", "")}`,
                                ],
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-12 col-lg-12 p-0 date-range",
                                  },
                                  [
                                    _c("ul", { staticClass: "pl-0 mt-6" }, [
                                      (_vm.types.label === "regWatch" &&
                                        _vm.permissions.includes(
                                          "REG_WTCH_REG_UPD_LAST_7_DAYS"
                                        )) ||
                                      _vm.types.label !== "regWatch"
                                        ? _c(
                                            "li",
                                            {
                                              staticClass: "col-xs-12 p-0",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDocumentDaysSelection(
                                                    "isLast7Days",
                                                    "commonDates"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-10 pl-0 sub-approval",
                                                  class: {
                                                    "font-bold":
                                                      _vm.totalDates.commonDates
                                                        .isLast7Days,
                                                  },
                                                },
                                                [_vm._v(" Last 7 days ")]
                                              ),
                                              _vm.totalDates.commonDates
                                                .isLast7Days
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "col-xs-2 p-0 text-right",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/check.svg",
                                                          alt: "check-icon",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      (_vm.types.label === "regWatch" &&
                                        _vm.permissions.includes(
                                          "REG_WTCH_REG_UPD_LAST_30_DAYS"
                                        )) ||
                                      _vm.types.label !== "regWatch"
                                        ? _c(
                                            "li",
                                            {
                                              staticClass: "col-xs-12 p-0",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDocumentDaysSelection(
                                                    "isLast30Days",
                                                    "commonDates"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-10 pl-0 sub-approval",
                                                  class: {
                                                    "font-bold":
                                                      _vm.totalDates.commonDates
                                                        .isLast30Days,
                                                  },
                                                },
                                                [_vm._v(" Last 30 days ")]
                                              ),
                                              _vm.totalDates.commonDates
                                                .isLast30Days
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "col-xs-2 p-0 text-right",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/check.svg",
                                                          alt: "check-icon",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                      (_vm.types.label === "regWatch" &&
                                        _vm.permissions.includes(
                                          "REG_WTCH_REG_UPD_LAST_YEAR"
                                        )) ||
                                      _vm.types.label !== "regWatch"
                                        ? _c(
                                            "li",
                                            {
                                              staticClass: "col-xs-12 p-0",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onDocumentDaysSelection(
                                                    "isLastYear",
                                                    "commonDates"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-10 pl-0 sub-approval",
                                                  class: {
                                                    "font-bold":
                                                      _vm.totalDates.commonDates
                                                        .isLastYear,
                                                  },
                                                },
                                                [_vm._v(" Within last year ")]
                                              ),
                                              _vm.totalDates.commonDates
                                                .isLastYear
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "col-xs-2 p-0 text-right",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/check.svg",
                                                          alt: "check-icon",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    (_vm.types.label === "regWatch" &&
                                      _vm.permissions.includes(
                                        "REG_WTCH_REG_UPD_POSTED_DATE_RANGE"
                                      )) ||
                                    _vm.types.label !== "regWatch"
                                      ? _c("filter-date", {
                                          attrs: {
                                            eventType: "commonDates",
                                            label: _vm.types.label,
                                            dateFormat: _vm.dateFormat,
                                          },
                                          on: {
                                            dateRange: function ($event) {
                                              return _vm.setCustomDateRange(
                                                $event,
                                                value,
                                                "commonDates"
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                        "collapseAccountType"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseAccountType col-xs-12 col-md-12 col-lg-12 p-0 item-divider",
                                class: { in: _vm.selection[keyValue] },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-12 col-lg-12 pr-0 date-range",
                                  },
                                  [
                                    _c("ul", { staticClass: "pl-0" }, [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "col-xs-12 p-0 sub-approval",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onAccountTypeOrStatusSelection(
                                                "rep",
                                                "accountType"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-xs-10 pl-0",
                                              class: {
                                                "font-bold":
                                                  _vm.filterOptions
                                                    .accountType === "rep",
                                              },
                                            },
                                            [_vm._v(" Rep ")]
                                          ),
                                          _vm.filterOptions.accountType ===
                                          "rep"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "col-xs-12 p-0 sub-approval",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onAccountTypeOrStatusSelection(
                                                "commercial",
                                                "accountType"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-xs-10 pl-0",
                                              class: {
                                                "font-bold":
                                                  _vm.filterOptions
                                                    .accountType ===
                                                  "commercial",
                                              },
                                            },
                                            [_vm._v(" Commercial ")]
                                          ),
                                          _vm.filterOptions.accountType ===
                                          "commercial"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm.types.label === "launchpadUsers"
                                        ? _c(
                                            "li",
                                            {
                                              staticClass:
                                                "col-xs-12 p-0 sub-approval",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onAccountTypeOrStatusSelection(
                                                    "repcommercial",
                                                    "accountType"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "col-xs-10 pl-0",
                                                  class: {
                                                    "font-bold":
                                                      _vm.filterOptions
                                                        .accountType ===
                                                      "repcommercial",
                                                  },
                                                },
                                                [_vm._v(" Rep/Commercial ")]
                                              ),
                                              _vm.filterOptions.accountType ===
                                              "repcommercial"
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "col-xs-2 p-0 text-right",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/check.svg",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                        "collapseConfirmStatus"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseAccountType col-xs-12 col-md-12 col-lg-12 p-0",
                                class: {
                                  in: _vm.selection[keyValue],
                                  "item-divider": _vm.includeDeactivatedUsers,
                                  "mt-7": !_vm.includeDeactivatedUsers,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-12 col-lg-12 pr-0 date-range",
                                  },
                                  [
                                    _c("ul", { staticClass: "pl-0" }, [
                                      _c(
                                        "li",
                                        {
                                          staticClass:
                                            "col-xs-12 p-0 sub-approval",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onAccountTypeOrStatusSelection(
                                                "confirmed",
                                                "confirmedType"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-xs-10 pl-0",
                                              class: {
                                                "font-bold":
                                                  _vm.filterOptions
                                                    .confirmedType ===
                                                  "confirmed",
                                              },
                                            },
                                            [_vm._v(" Confirmed ")]
                                          ),
                                          _vm.filterOptions.confirmedType ===
                                          "confirmed"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "col-xs-12 p-0 font-16",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onAccountTypeOrStatusSelection(
                                                "unconfirmed",
                                                "confirmedType"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col-xs-10 pl-0",
                                              class: {
                                                "font-bold":
                                                  _vm.filterOptions
                                                    .confirmedType ===
                                                  "unconfirmed",
                                              },
                                            },
                                            [_vm._v(" Unconfirmed ")]
                                          ),
                                          _vm.filterOptions.confirmedType ===
                                          "unconfirmed"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                        "collapseDateSigned"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseDateSigned col-xs-12 col-md-12 col-lg-12 p-0 item-divider",
                                class: { in: _vm.selection[keyValue] },
                              },
                              [
                                _c("filter-date", {
                                  attrs: {
                                    eventType: "signedDates",
                                    label: _vm.types.label,
                                    dateFormat: _vm.dateFormat,
                                  },
                                  on: {
                                    dateRange: function ($event) {
                                      return _vm.setCustomDateRange(
                                        $event,
                                        value,
                                        "commonDates"
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                        "collapseServiceExpiration"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseServiceExpiration col-xs-12 col-md-12 col-lg-12 p-0 item-divider",
                                class: { in: _vm.selection[keyValue] },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-12 col-lg-12 date-range",
                                  },
                                  [
                                    _c("ul", { staticClass: "pl-0 mt-6" }, [
                                      _c(
                                        "li",
                                        {
                                          staticClass: "col-xs-12 p-0",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDocumentDaysSelection(
                                                "isExpiringIn30Days",
                                                "serviceExpDates"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xs-10 pl-0 sub-approval",
                                              class: {
                                                "font-bold":
                                                  _vm.totalDates.serviceExpDates
                                                    .isExpiringIn30Days,
                                              },
                                            },
                                            [_vm._v(" Expiring in 30 days ")]
                                          ),
                                          _vm.totalDates.serviceExpDates
                                            .isExpiringIn30Days
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "col-xs-12 p-0",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDocumentDaysSelection(
                                                "isExpiringIn30To45Days",
                                                "serviceExpDates"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xs-10 pl-0 sub-approval",
                                              class: {
                                                "font-bold":
                                                  _vm.totalDates.serviceExpDates
                                                    .isExpiringIn30To45Days,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " Expiring > 30 days and "
                                              ),
                                              _c("br"),
                                              _vm._v(" ≤ 45 days "),
                                            ]
                                          ),
                                          _vm.totalDates.serviceExpDates
                                            .isExpiringIn30To45Days
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                    _c("filter-date", {
                                      attrs: {
                                        eventType: "serviceExpDates",
                                        label: _vm.types.label,
                                        dateFormat: _vm.dateFormat,
                                      },
                                      on: {
                                        dateRange: function ($event) {
                                          return _vm.setCustomDateRange(
                                            $event,
                                            value,
                                            "serviceExpDates"
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                        "collapseServicesRegistered"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseServicesRegistered col-xs-12 col-md-12 col-lg-12 p-0",
                                class: {
                                  in: _vm.selection[keyValue],
                                  "item-divider":
                                    _vm.includeDeactivatedAccounts,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-12 col-lg-12 pr-0 date-range",
                                  },
                                  [
                                    _c(
                                      "ul",
                                      { staticClass: "pl-0 mt-6" },
                                      _vm._l(
                                        _vm.servicesList,
                                        function (service, index) {
                                          return _c(
                                            "li",
                                            {
                                              key: index,
                                              staticClass: "col-xs-12 p-0",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.selectService(
                                                    service.name
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-10 pl-0 sub-approval",
                                                  class: {
                                                    "font-bold":
                                                      _vm.filterOptions.servicesRegistered.indexOf(
                                                        service.name
                                                      ) > -1,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(service.name) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm.filterOptions.servicesRegistered.indexOf(
                                                service.name
                                              ) > -1
                                                ? _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "col-xs-2 p-0 text-right",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/check.svg",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        (`collapse${value.replaceAll(" ", "")}` ===
                          "collapseAccountStatus" &&
                          _vm.includeDeactivatedAccounts) ||
                        (`collapse${value.replaceAll(" ", "")}` ===
                          "collapseUserStatus" &&
                          _vm.includeDeactivatedUsers)
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse col-xs-12 col-md-12 col-lg-12 p-0",
                                class: {
                                  in: _vm.selection[keyValue],
                                  collapseAccountStatus:
                                    _vm.includeDeactivatedAccounts,
                                  collapseUserStatus:
                                    _vm.includeDeactivatedUsers,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-12 col-lg-12 date-range pr-0",
                                  },
                                  [
                                    _c("ul", { staticClass: "pl-0 mt-6" }, [
                                      _c(
                                        "li",
                                        {
                                          staticClass: "col-xs-12 p-0",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onAccountTypeOrStatusSelection(
                                                "active",
                                                _vm.mappedValues[value]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xs-10 pl-0 sub-approval",
                                              class: {
                                                "font-bold":
                                                  _vm.filterOptions[
                                                    _vm.mappedValues[value]
                                                  ] === "active",
                                              },
                                            },
                                            [_vm._v(" Active ")]
                                          ),
                                          _vm.filterOptions[
                                            _vm.mappedValues[value]
                                          ] === "active"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "col-xs-12 p-0",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onAccountTypeOrStatusSelection(
                                                "deactivated",
                                                _vm.mappedValues[value]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xs-10 pl-0 sub-approval",
                                              class: {
                                                "font-bold":
                                                  _vm.filterOptions[
                                                    _vm.mappedValues[value]
                                                  ] === "deactivated",
                                              },
                                            },
                                            [_vm._v(" Deactivated ")]
                                          ),
                                          _vm.filterOptions[
                                            _vm.mappedValues[value]
                                          ] === "deactivated"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                        "collapseCategory"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseCategory col-xs-12 col-md-12 col-lg-12 mt-10 p-0",
                                class: { in: _vm.selection[keyValue] },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "form-group" },
                                  [
                                    _c(
                                      "base-tooltip",
                                      {
                                        attrs: {
                                          content: _vm.tooltips.category,
                                          placement: "top",
                                          disabled:
                                            !_vm.filterOptions.categories,
                                          "popper-class":
                                            "br-10 w-250 custom-doc-el-select",
                                        },
                                      },
                                      [
                                        _c("multiselect", {
                                          staticClass:
                                            "multiselect-single-dropdown",
                                          attrs: {
                                            showLabels: false,
                                            "close-on-select": true,
                                            "allow-empty": false,
                                            "open-direction": "bottom",
                                            searchable: false,
                                            options:
                                              _vm.availableCategoriesList.map(
                                                (category) => category.id
                                              ),
                                            "custom-label": (option) =>
                                              _vm.availableCategoriesList.find(
                                                (x) => x.id === option
                                              ).name,
                                            placeholder: "Select Category",
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.setSubCategoriesList(
                                                _vm.filterOptions.categories
                                              )
                                            },
                                          },
                                          model: {
                                            value: _vm.filterOptions.categories,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filterOptions,
                                                "categories",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filterOptions.categories",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.filterOptions.categories &&
                        `collapse${value.replaceAll(" ", "")}` ===
                          "collapseSubCategory"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseSubCategory col-xs-12 col-md-12 p-0 col-lg-12 mt-10",
                                class: { in: _vm.selection[keyValue] },
                              },
                              [
                                _c("div", { staticClass: "col-xs-12 p-0" }, [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c(
                                        "base-tooltip",
                                        {
                                          attrs: {
                                            content: _vm.tooltips.subCategory,
                                            placement: "top",
                                            disabled:
                                              !_vm.filterOptions.subCategories,
                                            "popper-class": "w-250",
                                          },
                                        },
                                        [
                                          _c("multiselect", {
                                            staticClass:
                                              "multiselect-single-dropdown",
                                            attrs: {
                                              showLabels: false,
                                              "close-on-select": true,
                                              "allow-empty": false,
                                              "open-direction": "bottom",
                                              searchable: false,
                                              options:
                                                _vm.availableSubCategoriesList.map(
                                                  (subCategory) =>
                                                    subCategory.id
                                                ),
                                              "custom-label": (option) =>
                                                _vm.availableSubCategoriesList.find(
                                                  (x) => x.id === option
                                                ).name,
                                              placeholder:
                                                "Select Sub-category",
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.setTooltipForSubcategories(
                                                  _vm.filterOptions
                                                    .subCategories
                                                )
                                              },
                                            },
                                            model: {
                                              value:
                                                _vm.filterOptions.subCategories,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filterOptions,
                                                  "subCategories",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterOptions.subCategories",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                          "collapseCountry" && keyValue === "isCountryChevron"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseCountry col-xs-12 col-md-12 col-lg-12 mt-10 multiple-select-zindex p-0",
                                class: { in: _vm.selection[keyValue] },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-xs-12 countries-list" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 p-0 search-container-wraper",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "search-container col-xs-12 p-0",
                                          },
                                          [
                                            _c("search-box", {
                                              on: {
                                                getList: function ($event) {
                                                  return _vm.filterCountriesList()
                                                },
                                              },
                                              model: {
                                                value: _vm.countryName,
                                                callback: function ($$v) {
                                                  _vm.countryName = $$v
                                                },
                                                expression: "countryName",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm.availableCountriesList.length
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-12 p-0 pt-10 element-scroll-bar",
                                          },
                                          [
                                            _c(
                                              "ul",
                                              {
                                                staticClass: "row m-0",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                  },
                                                },
                                              },
                                              _vm._l(
                                                _vm.availableCountriesList,
                                                function (country) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: _vm.isCountryString
                                                        ? country
                                                        : country[
                                                            _vm.types.countryId
                                                          ],
                                                      staticClass: "col-xs-12",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox inline-checkbox",
                                                        },
                                                        [
                                                          _c("label", [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.selectedCountryIdList,
                                                                  expression:
                                                                    "selectedCountryIdList",
                                                                },
                                                              ],
                                                              attrs: {
                                                                type: "checkbox",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.isCountryString
                                                                    ? country
                                                                    : country[
                                                                        _vm
                                                                          .types
                                                                          .countryId
                                                                      ],
                                                                checked:
                                                                  Array.isArray(
                                                                    _vm.selectedCountryIdList
                                                                  )
                                                                    ? _vm._i(
                                                                        _vm.selectedCountryIdList,
                                                                        _vm.isCountryString
                                                                          ? country
                                                                          : country[
                                                                              _vm
                                                                                .types
                                                                                .countryId
                                                                            ]
                                                                      ) > -1
                                                                    : _vm.selectedCountryIdList,
                                                              },
                                                              on: {
                                                                change: [
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    var $$a =
                                                                        _vm.selectedCountryIdList,
                                                                      $$el =
                                                                        $event.target,
                                                                      $$c =
                                                                        $$el.checked
                                                                          ? true
                                                                          : false
                                                                    if (
                                                                      Array.isArray(
                                                                        $$a
                                                                      )
                                                                    ) {
                                                                      var $$v =
                                                                          _vm.isCountryString
                                                                            ? country
                                                                            : country[
                                                                                _vm
                                                                                  .types
                                                                                  .countryId
                                                                              ],
                                                                        $$i =
                                                                          _vm._i(
                                                                            $$a,
                                                                            $$v
                                                                          )
                                                                      if (
                                                                        $$el.checked
                                                                      ) {
                                                                        $$i <
                                                                          0 &&
                                                                          (_vm.selectedCountryIdList =
                                                                            $$a.concat(
                                                                              [
                                                                                $$v,
                                                                              ]
                                                                            ))
                                                                      } else {
                                                                        $$i >
                                                                          -1 &&
                                                                          (_vm.selectedCountryIdList =
                                                                            $$a
                                                                              .slice(
                                                                                0,
                                                                                $$i
                                                                              )
                                                                              .concat(
                                                                                $$a.slice(
                                                                                  $$i +
                                                                                    1
                                                                                )
                                                                              ))
                                                                      }
                                                                    } else {
                                                                      _vm.selectedCountryIdList =
                                                                        $$c
                                                                    }
                                                                  },
                                                                  _vm.setFilteredCountriesList,
                                                                ],
                                                              },
                                                            }),
                                                            _c("span", {
                                                              staticClass: "cr",
                                                            }),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "countries",
                                                          class: {
                                                            "active-country":
                                                              _vm.selectedCountryIdList.indexOf(
                                                                _vm.isCountryString
                                                                  ? country
                                                                  : country[
                                                                      _vm.types
                                                                        .countryId
                                                                    ]
                                                              ) > -1,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.isCountryString
                                                                ? country
                                                                : country[
                                                                    _vm.types
                                                                      .countryName
                                                                  ]
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-12 text-center font-16 mt-10",
                                          },
                                          [_vm._v("No countries found.")]
                                        ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                          "collapseCountry" &&
                        keyValue === "isMultiSelectCountryChevron"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseCountry col-xs-12 col-md-12 col-lg-12 mt-10 multiple-select-zindex",
                                class: { in: _vm.selection[keyValue] },
                              },
                              [
                                _c(
                                  "multiselect",
                                  {
                                    staticClass:
                                      "multiselect-single-dropdown multiselect-multiple rectangular-border",
                                    attrs: {
                                      showLabels: false,
                                      "close-on-select": false,
                                      placeholder: "Country",
                                      label: "country_code",
                                      "track-by": "id",
                                      multiple: true,
                                      searchable: true,
                                      "clear-on-select": false,
                                      options: _vm.countriesList,
                                      value: _vm.selectedCountryIdList,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function ({ values, isOpen }) {
                                            return _c(
                                              "div",
                                              {
                                                staticClass: "selection-count",
                                              },
                                              [
                                                !isOpen &&
                                                values.length ==
                                                  _vm.countriesList.length
                                                  ? [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/filter.svg",
                                                          alt: "filter-icon",
                                                        },
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "selected-count",
                                                        },
                                                        [_vm._v("All")]
                                                      ),
                                                    ]
                                                  : !isOpen
                                                  ? [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/filter.svg",
                                                          alt: "filter-icon",
                                                        },
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "selected-count",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              values.length
                                                            ) + " Selected"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  : isOpen
                                                  ? [
                                                      _c("img", {
                                                        staticClass:
                                                          "image-size",
                                                        attrs: {
                                                          src: "/static/images/icons/filter.svg",
                                                          alt: "filter-icon",
                                                        },
                                                      }),
                                                    ]
                                                  : _vm._e(),
                                              ],
                                              2
                                            )
                                          },
                                        },
                                        {
                                          key: "option",
                                          fn: function (props) {
                                            return _c("span", {}, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "d-flex",
                                                  on: {
                                                    input: function ($event) {
                                                      return _vm.toggleCBValue(
                                                        props.option
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checkbox inline-checkbox",
                                                    },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            value:
                                                              props.option
                                                                .productName,
                                                            checked:
                                                              props.option
                                                                .selected,
                                                          },
                                                        }),
                                                        _c("span", {
                                                          staticClass: "cr",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toggleCBValue(
                                                            props.option
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            props.option
                                                              .country_name
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ])
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "noResult" },
                                        slot: "noResult",
                                      },
                                      [_vm._v("No matching data")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                        "collapseEffectiveDate"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseEffectiveDate col-xs-12 col-md-12 col-lg-12 mt-10 p-0",
                                class: { in: _vm.selection[keyValue] },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-12 col-lg-12 p-0 date-range",
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-12 col-md-12 col-lg-12 date-range",
                                      },
                                      [
                                        _c("ul", { staticClass: "pl-0 mt-6" }, [
                                          (_vm.types.label === "regWatch" &&
                                            _vm.permissions.includes(
                                              "REG_WTCH_REG_UPD_NEXT_30_DAYS"
                                            )) ||
                                          _vm.types.label !== "regWatch"
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass: "col-xs-12 p-0",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDocumentDaysSelection(
                                                        "isNext30Days",
                                                        "effectiveDates"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-10 pl-0 sub-approval",
                                                      class: {
                                                        "font-bold":
                                                          _vm.totalDates
                                                            .effectiveDates
                                                            .isNext30Days,
                                                      },
                                                    },
                                                    [_vm._v(" Next 30 Days ")]
                                                  ),
                                                  _vm.totalDates.effectiveDates
                                                    .isNext30Days
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "col-xs-2 p-0 text-right",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "image-size",
                                                            attrs: {
                                                              src: "/static/images/icons/check.svg",
                                                              alt: "check-icon",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                          (_vm.types.label === "regWatch" &&
                                            _vm.permissions.includes(
                                              "REG_WTCH_REG_UPD_NEXT_6_MONTHS"
                                            )) ||
                                          _vm.types.label !== "regWatch"
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass: "col-xs-12 p-0",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDocumentDaysSelection(
                                                        "isNext6Months",
                                                        "effectiveDates"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-10 pl-0 sub-approval",
                                                      class: {
                                                        "font-bold":
                                                          _vm.totalDates
                                                            .effectiveDates
                                                            .isNext6Months,
                                                      },
                                                    },
                                                    [_vm._v(" Next 6 Months ")]
                                                  ),
                                                  _vm.totalDates.effectiveDates
                                                    .isNext6Months
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "col-xs-2 p-0 text-right",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "image-size",
                                                            attrs: {
                                                              src: "/static/images/icons/check.svg",
                                                              alt: "check-icon",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                          (_vm.types.label === "regWatch" &&
                                            _vm.permissions.includes(
                                              "THIS_YEAR"
                                            )) ||
                                          _vm.types.label !== "regWatch"
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass: "col-xs-12 p-0",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDocumentDaysSelection(
                                                        "isThisYear",
                                                        "effectiveDates"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-10 pl-0 sub-approval",
                                                      class: {
                                                        "font-bold":
                                                          _vm.totalDates
                                                            .effectiveDates
                                                            .isThisYear,
                                                      },
                                                    },
                                                    [_vm._v(" This Year ")]
                                                  ),
                                                  _vm.totalDates.effectiveDates
                                                    .isThisYear
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "col-xs-2 p-0 text-right",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "image-size",
                                                            attrs: {
                                                              src: "/static/images/icons/check.svg",
                                                              alt: "check-icon",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                          (_vm.types.label === "regWatch" &&
                                            _vm.permissions.includes(
                                              "REG_WTCH_REG_UPD_NEXT_YEAR"
                                            )) ||
                                          _vm.types.label !== "regWatch"
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass: "col-xs-12 p-0",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onDocumentDaysSelection(
                                                        "isNextYear",
                                                        "effectiveDates"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-10 pl-0 sub-approval",
                                                      class: {
                                                        "font-bold":
                                                          _vm.totalDates
                                                            .effectiveDates
                                                            .isNextYear,
                                                      },
                                                    },
                                                    [_vm._v(" Next Year ")]
                                                  ),
                                                  _vm.totalDates.effectiveDates
                                                    .isNextYear
                                                    ? _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "col-xs-2 p-0 text-right",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "image-size",
                                                            attrs: {
                                                              src: "/static/images/icons/check.svg",
                                                              alt: "check-icon",
                                                            },
                                                          }),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                        (_vm.types.label === "regWatch" &&
                                          _vm.permissions.includes(
                                            "REG_WTCH_REG_UPD_EFF_DATE_RANGE"
                                          )) ||
                                        _vm.types.label !== "regWatch"
                                          ? _c("filter-date", {
                                              attrs: {
                                                eventType: "effectiveDates",
                                                label: _vm.types.label,
                                                dateFormat: _vm.dateFormat,
                                              },
                                              on: {
                                                dateRange: function ($event) {
                                                  return _vm.setCustomDateRange(
                                                    $event,
                                                    value,
                                                    "effectiveDates"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        `collapse${value.replaceAll(" ", "")}` ===
                        "collapseExpirationDate"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "collapse collapseExpirationDate col-xs-12 col-md-12 col-lg-12 mt-10 p-0",
                                class: { in: _vm.selection[keyValue] },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-12 col-md-12 col-lg-12 p-0 date-range",
                                  },
                                  [
                                    _c("ul", { staticClass: "pl-0 mt-6" }, [
                                      _c(
                                        "li",
                                        {
                                          staticClass: "col-xs-12 p-0",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDocumentDaysSelection(
                                                "isThisMonth",
                                                "expirationDates"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xs-10 pl-0 sub-approval",
                                              class: {
                                                "font-bold":
                                                  _vm.totalDates.expirationDates
                                                    .isThisMonth,
                                              },
                                            },
                                            [_vm._v(" This month ")]
                                          ),
                                          _vm.totalDates.expirationDates
                                            .isThisMonth
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "col-xs-12 p-0",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDocumentDaysSelection(
                                                "isNext3Months",
                                                "expirationDates"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xs-10 pl-0 sub-approval",
                                              class: {
                                                "font-bold":
                                                  _vm.totalDates.expirationDates
                                                    .isNext3Months,
                                              },
                                            },
                                            [_vm._v(" Next 3 months ")]
                                          ),
                                          _vm.totalDates.expirationDates
                                            .isNext3Months
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "li",
                                        {
                                          staticClass: "col-xs-12 p-0",
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDocumentDaysSelection(
                                                "isThisYear",
                                                "expirationDates"
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xs-10 pl-0 sub-approval",
                                              class: {
                                                "font-bold":
                                                  _vm.totalDates.expirationDates
                                                    .isThisYear,
                                              },
                                            },
                                            [_vm._v(" Within this year ")]
                                          ),
                                          _vm.totalDates.expirationDates
                                            .isThisYear
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "col-xs-2 p-0 text-right",
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass: "image-size",
                                                    attrs: {
                                                      src: "/static/images/icons/check.svg",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                    _c("filter-date", {
                                      attrs: {
                                        eventType: "expirationDates",
                                        label: _vm.types.label,
                                        dateFormat: _vm.dateFormat,
                                      },
                                      on: {
                                        dateRange: function ($event) {
                                          return _vm.setCustomDateRange(
                                            $event,
                                            value,
                                            "expirationDates"
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              ),
              (_vm.types.label === "records" &&
                _vm.permissions.includes("CLEAR_ALL")) ||
              _vm.types.label !== "records"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 text-right clear-option cursor-pointer pr-0",
                      class: { "cursor-pointer-disable": !_vm.showFilterIcon },
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { disabled: !_vm.showFilterIcon },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.clearAll()
                            },
                          },
                        },
                        [_vm._v("Clear All")]
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "col-xs-1 p-0 pr-8",
        attrs: { "data-toggle": "dropdown" },
      },
      [
        _c("img", {
          staticClass: "image-size",
          attrs: { src: "/static/images/icons/filter.svg", alt: "filter-icon" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }